module.exports = __webpack_public_path__ + "static/media/wick.d7216cd3.png";